import { render, staticRenderFns } from "./NavbarStyleTwo.vue?vue&type=template&id=472f35a4&"
import script from "./NavbarStyleTwo.vue?vue&type=script&lang=js&"
export * from "./NavbarStyleTwo.vue?vue&type=script&lang=js&"
import style0 from "./NavbarStyleTwo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports